// extracted by mini-css-extract-plugin
export default {"outer_container":"Container_outer_container__sthIs","container":"Container_container__KIw34"};